<template lang="html">
  <div>
    <el-dialog width="65%" :before-close="beforeClose"
      :title="$t('message.equipmentInquire')" :visible.sync=dialogVisible :fullscreen=true >

      <!-- 搜索区 -->
      <el-row :gutter="10" type="flex" align="middle">
        <el-col :span="4">{{$t('message.searchKeyword')}}</el-col>
        <el-col :span="20">
          <el-input :placeholder="$t('message.commonTip')" v-model="searchKeyword" class="keyword-input" @keyup.enter.native="searchTerminal">
            <el-select v-model="queryType" slot="prepend" placeholder="$t('message.pleaseChoose')" class="keyword-input-select">
              <el-option v-for="item in queryOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-input>
        </el-col>
      </el-row>

      <!-- 地区搜索 -->
      <el-row :gutter="10" type="flex" align="middle" class="area-row">
        <el-col :span="4">{{$t('message.selectArea')}}</el-col>
        <el-col :span="5">
          <el-select v-model="currentCountry" :placeholder="$t('message.country')" @change="loadStateList" >
            <el-option v-for="item in countryList" :key="item.id" :label="item.name" :value="item.id" @click.native="initState"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select  v-model="currentState" :placeholder="$t('message.province')" @change="loadCityList">
            <el-option v-for="item in stateList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select  v-model="currentCity" :placeholder="$t('message.city')" @change="loadDistrict">
            <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select  v-model="currentDistrict" :placeholder="$t('message.area')" @change="loadArea">
            <el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-col>
        <el-col :span="1">
          <el-button class="search-btn" icon="el-icon-search" @click="searchTerminal"/>
        </el-col>
      </el-row>

      <!-- 数据展示区 -->
      <!--<div class="verifone-panel">-->
        <div class="group-terminal-selector-table-main btn-table">
          <el-table class="group-terminal-table yy-table" :data="tableData" stripe border max-height="360" height="360"
            @selection-change="selectionChange">
            <!-- 复选框 -->
            <el-table-column type="selection" min-width="40" />

            <!-- SN -->
            <el-table-column prop="sn" :label="$t('message.sn')" min-width="170"/>

            <!-- 型号 -->
            <el-table-column prop="model" :label="$t('message.model')" min-width="120"/>

            <!-- 设备ID -->
            <el-table-column prop="deviceId" :label="$t('message.deviceId')" min-width="130"/>

            <!-- 商户 -->
            <el-table-column prop="merchantName" :label="$t('message.merchant')" min-width="370"/>
          </el-table>
        </div>
     <!-- </div>-->

      <!-- 按钮 -->
      <div class="flex-row footer-contain">
        <el-button class="verifone-btn" type="primary" icon="el-icon-plus" @click="emitTerminal">{{$t('message.join')}}</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
    export default {
      mounted() {
        this.loadCountry();
      },
      props:{
        dialogVisible:{
          type: Boolean,
          required: true
        }
      },
      data(){
        return{
          /*--------------------------------------------- 搜索信息 start ---------------------------------------------*/
          searchKeyword:'', // 搜索条件
          queryType: 0, // 条件类型框 默认值
          queryOptions: [ {
            value: 0,
            label: this.$t('message.sn')
          },{
            value: 1,
            label: this.$t('message.companies')
          },{
            value: 2,
            label: this.$t('message.address')
          }],
          countryList:[],
          stateList:[],
          cityList:[],
          districtList:[],
          currentCountry:'',
          currentState:'',
          currentCity:'',
          currentDistrict:'',
          /*--------------------------------------------- 搜索信息 end ---------------------------------------------*/

          /*--------------------------------------------- 表格信息 start -------------------------------------------*/
          tableData:[],
          selectTerminals:[], //选中的信息
          /*--------------------------------------------- 表格信息 end ---------------------------------------------*/

          /*--------------------------------------------- 提示信息 start ---------------------------------------------*/
          no: this.$t('message.no'),
          yes: this.$t('message.yes'),
          warning: this.$t('message.warning'),
          noTickTerminal: this.$t('message.noTickTerminal')
          /*--------------------------------------------- 提示信息 end -----------------------------------------------*/
        }
      },
      methods:{
        initState(){
          this.districtList=[];
          this.cityList=[];
          this.currentState='';
          this.currentCity='';
          this.currentDistrict='';
        },

        loadCountry(row){
          let that = this,
            obj = {
              countryId: null,
            };
          this.countryList.forEach(item => {
            if(item.id == row) {
              this.countryName = item.name;
              return;
            }
          });
          this.$axios({
            method: 'post',
            url: '/marketplace/common/query/country',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
          }).then(response => {
            if (response.data.resultCode != 0) {
              this.$message({
                type: "error",
                message: response.data.desc,
                duration:'3000',
              });
              return;
            }else {
              that.countryList = response.data.countries;
            }
          }).catch((err) => {
            console.log(err);
          });
        },

        loadStateList(row){
          console.log("loadState");
          let that = this,
            obj = {
              countryId: that.currentCountry,
            };
          this.countryList.forEach(item => {
            if(item.id == row) {
              this.countryName = item.name;
              return;
            }
          });

          this.$axios({
            method: 'post',
            url: '/marketplace/common/query/state',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
          }).then(response => {
            if (response.data.resultCode != 0) {
              this.$message({
                type: "error",
                message: response.data.desc,
                duration:'3000',
              });
              return;
            }else {
              that.stateList = response.data.states;
            }
          }).catch((err) => {
            console.log(err);
          });
        },

        loadCityList(row) {
          console.log("loadCity");
          let that = this,
            obj = {
              stateId:that.currentState
            };

          this.stateList.forEach(item => {
            if(item.id == row) {
              this.provinceName = item.name;
              return;
            }
          });

          this.$axios({
            method: 'post',
            url: '/marketplace/common/query/city',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
          }).then(response => {
            if (response.data.resultCode != 0) {
              this.$message({
                type: "error",
                message: response.data.desc,
                duration:'3000',
              });
              return;
            }else {
              that.cityList = response.data.cities;
              console.log(that.cityList);
            }
          }).catch((err) => {
            console.log(err);
          });
        },

        loadDistrict(row){
          console.log("loadDistrict");
          let that = this,
            obj = {
              cityId: that.currentCity
            };

          this.cityList.forEach(item => {
            if(item.id == row) {
              this.cityName = item.name;
              return;
            }
          });

          this.$axios({
            method: 'post',
            url: '/marketplace/common/query/district',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
          }).then(response => {
            if (response.data.resultCode != 0) {
              this.$message({
                type: "error",
                message: response.data.desc,
                duration:'3000',
              });
              return;
            }else {
              that.districtList = response.data.districts;
            }
          }).catch((err) => {
            console.log(err);
          });
        },

        loadArea(row) {
          this.districtList.forEach(item => {
            if(item.id == row) {
              this.areaName = item.name;
              return;
            }
          });
        },

        searchTerminal(){
          let that = this,
            obj = {
              countryId: this.currentCountry,
              stateId:this.currentState,
              cityId:this.currentCity,
              districtId:this.currentDistrict,
              queryType:this.queryType,
              queryInfo:this.searchKeyword
            };

          this.$axios({
            method: 'post',
            url: '/marketplace/group/terminal/search',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
          }).then(response => {
            if (response.data.resultCode != 0) {
              this.$message({
                type: "error",
                message: response.data.desc,
                duration:'3000',
              });
              return;
            }else {
              that.tableData = response.data.terminals;
            }
          }).catch((err) => {
            console.log(err);
          });
        },

        beforeClose(){
          this.initSearch();
          this.$emit('close',null);
        },
        initSearch(){
          // 清空查询历史结果
          this.tableData = [];

          // 设备默认查询条件
          this.queryType = 0;
          this.searchKeyword = '';

          // 清空地区条件
          this.currentCountry = '';
          this.currentState = '';
          this.currentCity = '';
          this.currentDistrict = '';
          this.stateList = [];
          this.cityList = [];
          this.districtList = [];
        },

        selectionChange(rows){
          this.selectTerminals = rows;
        },

        // 发射用户选中的终端
        emitTerminal(){
          let that = this;
          // 用户没有进行数据查询，直接关闭窗口
          if(this.tableData.length == 0){
            this.beforeClose();
            return;
          }

          if(this.selectTerminals.length == 0){
            // 提示用户没有勾选，询问是否全部发射
            this.$confirm(this.noTickTerminal, this.warning, {
              confirmButtonText: this.yes,
              cancelButtonText: this.no,
              type: "warning"
            }).then(() => {
              that.$emit("emitTerminal",that.tableData);
              this.beforeClose();
            }).catch(() => {
              console.log("emitTerminal -> 用户取消");
            });
          }else{
            this.$emit("emitTerminal",this.selectTerminals);
            this.beforeClose();
          }
        },

      }
    }
</script>

<style scoped>
  .group-terminal-table {
    width: 100%
  }

  .footer-contain {
    justify-content: flex-end;
    padding-right: 20px;
    padding-top:20px;
  }

  .group-terminal-selector-table-main {
    background-color: #fff;

    margin: 20px auto 10px;
  }

  .keyword-input {
    width: 400px;
  }

  .keyword-input-select {
    width: 120px;
  }

  .area-row {
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/group/GroupTerminalSelector.vue